module.exports = __webpack_public_path__ + "img/9788960172418.8a15cf32.jpg";